$.namespace(
  'MemePlayerAgora',
  $.Class(function (klass) {
    this.roomId = '';

    this.video = null;
    this.client = null;

    this.audioTrack = null;
    this.options = null;

    this.log = function () {
      var args = [];
      _.forEach(arguments, function (value) {
        args.push(value);
      });

      debug.apply(null, ['【MemePlayerAgora-' + this.roomId + '】'].concat(args));
    };

    this.init = function (roomId, video, options) {
      this.log('init');
      this.roomId = roomId;
      this.video = video;
      this.options = options;
      this.initClient();
    };

    this.initClient = async function () {
      this.client = window.AgoraRTC.createClient({
        mode: 'live',
        codec: 'h264',
      });
      this.client.setClientRole('audience', { level: 1 });
      this.log('join start');
      const [token, userId] = await this.getToken();
      await this.client.join(
        MM.config.isRelease() || MM.config.isGrey()
          ? '7296ac09bc90468d89ce7463eb2cf26b'
          : '3f574f3c41a94d6098e0a6828fdcfadd',
        `${this.roomId}`,
        token,
        userId,
      );

      this.log('join success');
      this.client.on('user-published', async (user, mediaType) => {
        await this.client.subscribe(user, mediaType);
        this.log('play', mediaType, this.video);
        if (mediaType === 'video') {
          user.videoTrack.play(this.video, {
            fit: this.options.objectFit,
          });
        }
        if (mediaType === 'audio') {
          this.audioTrack = user.audioTrack;
          user.audioTrack.play();
        }
      });
      this.client.on('user-unpublished', async (user, mediaType) => {
        await this.client.unsubscribe(user, mediaType);
      });
    };

    this.getToken = function () {
      return new Promise((resolve, reject) => {
        request.post({
          url: '/api/v1/liveRoom/enter',
          data: {
            room_ids: [this.roomId],
          },
          urlType: 'cryolite',
          success: (res) => {
            this.log('getToken', res);
            resolve([res.data.token_map[this.roomId].room_token, res.data.user_id]);
          },
        });
      });
    };

    this.setVolume = function (val) {
      this.log('setVolume', val);
      this.audioTrack?.setVolume(val * 100);
    };

    this.destroy = function () {
      this.client.leave();
    };
  }),
);
